export default __webpack_public_path__ + "static/media/regulatory--dual-speed-limits--g2.4ac2d6f3.png";